import React from 'react';

const Ping = () => (
  <p>
    Pong!
  </p>
);

export default Ping;
